import { FC } from "react";
import "./Customer360Card.css";
import { CONSTANTS } from "utils/constants/constants";

interface HeaderCardProps {
  firstKey: string;
  secondKey: string;
  thirdKey: string;
  firstValue: string;
  secondValue: string;
  thirdValue: string;
  cardType: typeof CONSTANTS.HEADER;

}

interface GenricHeaderCardProps {
  items?: Array<{key: string, value: any}>;
  itemsPerRow?: number;
  cardType: typeof CONSTANTS.GENRIC_HEADER;
}

interface DetailsCardProps {
  cardType: typeof CONSTANTS.CARDS;
  cardFilteredDetails: any;
}

interface CardTransactions {
  cardType: typeof CONSTANTS.OFFER;
  filteredCardTransactions: any;
}

const Customer360Card: FC<
  HeaderCardProps | DetailsCardProps | CardTransactions | GenricHeaderCardProps
> = ({ ...data }) => {
  if (data.cardType === CONSTANTS.HEADER) {
  return(
  <div className="py-2 d-flex  flex-column gap-3 justify-content-center c-three-sixty-header-card p-3">
    <div className="d-flex justify-content-between gap-3">
      <span>{data.firstKey}</span>
      <span className="text-overflow-ellipsis">{data.firstValue}</span>
    </div>
    <div className="d-flex justify-content-between gap-3">
      <span>{data.secondKey}</span>
      <span className="text-overflow-ellipsis">{data.secondValue}</span>
    </div>
    <div className="d-flex justify-content-between gap-3">
      <span>{data.thirdKey}</span>
      <span className="text-overflow-ellipsis"> {data.thirdValue}</span>
    </div>
  </div>
  )
  }else  if (data.cardType === CONSTANTS.GENRIC_HEADER) {
    // Handle HEADER type with dynamic items
    const itemsPerRow = data.itemsPerRow || 3;
    const items = data.items || [];
    
    if (!items.length) return null;

    // Split items into groups for each card
    const itemGroups = [];
    for (let i = 0; i < items.length; i += itemsPerRow) {
      itemGroups.push(items.slice(i, i + itemsPerRow));
    }

    return (
      <div className="d-flex w-100 justify-content-between flex-wrap">
        {itemGroups.map((group, groupIndex) => (
          <div 
            key={groupIndex}
            className="py-2 d-flex flex-column gap-3 justify-content-center c-three-sixty-header-card p-3"
          >
            {group.map((item, index) => (
              <div key={index} className="d-flex justify-content-between gap-3">
                <span>{item.key}</span>
                <span className="text-overflow-ellipsis">{item.value?.toString()}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
 
  else if (data.cardType === CONSTANTS.CARDS) {
    return (
      <div className="d-flex ">
        {data.cardFilteredDetails
          ?.filter((card: any) => card.length > 0)
          .map((card: any, index: number) => (
            <div
              key={index}
              className="p-4 d-flex flex-column gap-2 c-three-sixty-card-details me-2"
            >
              {card.map((prop: any) => (
                <div
                  key={prop.label}
                  className="d-flex justify-content-between gap-3"
                >
                  <span>{prop.label}</span>
                  <span className="text-overflow-ellipsis">{prop.value?.toString()}</span>
                </div>
              ))}
            </div>
          ))}
      </div>
    );
  } else if (data.cardType === CONSTANTS.OFFER) {
    return (
      <div className="c-three-sixty-transaction-card-scrollable-container w-100">
        {data.filteredCardTransactions?.map((chunks: any, index: any) => (
          <div key={index} className="d-flex flex-column">
            {chunks.map((chunk: any, chunkIndex: any) => (
              <div
                key={chunkIndex}
                className="p-4 d-flex flex-column gap-2 c-three-sixty-array-data  mb-2"
              >
                {chunk.map(
                  (prop: any, idx: number) =>
                    prop.label === "Transaction ID" && (
                      <div key={idx} className="transaction-code-container mb-3">
                        <span className="transaction-code-text">
                          {prop.label}: {prop.value}
                        </span>
                      </div>
                    )
                )}
                {chunk.map(
                  (prop: any, idx: number) =>
                    prop.label !== "Transaction ID" && (
                      <div
                        key={idx}
                        className="d-flex justify-content-between gap-3"
                      >
                        <span>{prop.label}</span>
                        <span className="text-overflow-ellipsis">{prop.value}</span>
                      </div>
                    )
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default Customer360Card;